(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["special-order-notice"] && !Shopify.designMode) return;
  try {
    (() => {
  const selector = '[data-special-order-notice]';

  const getVariantMap = (notice) => {
    const data = notice.querySelector('[data-special-order-variants]');
    if (!data) return {};

    try {
      return JSON.parse(data.textContent);
    } catch (error) {
      return {};
    }
  };

  const updateNotice = (notice, variant) => {
    const variantMap = getVariantMap(notice);
    const shouldShow = Boolean(variant && variantMap[String(variant.id)]);
    notice.classList.toggle('hide', !shouldShow);
  };

  const initialize = (scope) => {
    scope.querySelectorAll(selector).forEach((notice) => {
      if (notice.dataset.specialOrderReady === 'true') return;

      notice.dataset.specialOrderReady = 'true';
      updateNotice(notice, { id: notice.dataset.variantId });

      const section = notice.closest('[data-product-id]');
      if (section) {
        section.addEventListener('variantChange', (event) => {
          updateNotice(notice, event.detail && event.detail.variant);
        });
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(document));
  } else {
    initialize(document);
  }

  document.addEventListener('quickview:loaded', (event) => {
    initialize(event.target || document);
  });
})();
  } catch(e) { console.error(e); }
})();

})();
